import { autoinject, bindable } from 'aurelia-framework';
import { PluckingListDto } from 'models/mooring';
import { clone } from 'lib/helpers';

@autoinject
export class Buoys {
  @bindable
  public productionOrderId: number;

  @bindable
  public pluckList: PluckingListDto[] = [];

  @bindable
  protected onSave: (args: { entries: PluckingListDto[]; canNavigateOnSave: boolean }) => void;

  constructor() {}

  protected handleSave() {
    this.onSave({ canNavigateOnSave: true, entries: clone(this.pluckList) });
  }
}
